import React from 'react';

import { teamMembers } from '../../../data';

import { MemberCard } from './MemberCard';

import '../../../css/components/about-us/meet-the-team.scss';
export function MeetTheTeam() {
  const memberCards = teamMembers.map((member, index) => {
    return (
      <MemberCard { ...member } key={ index } />
    )
  })
  return (
    <div className="MeetTheTeam">
      <div className="header">
        Come meet the wizards of the table.
      </div>
      <div className="cards">
        { memberCards }
      </div>
    </div>
  )
}